// extracted by mini-css-extract-plugin
module.exports = {"themeBanner":"theme-banner-module--theme-banner--20Fhq","bannerText":"theme-banner-module--banner-text--1r8d9","readMore":"theme-banner-module--read-more--12S8_"};